import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {Observable} from 'rxjs/Observable';
import {AuthProvider, AuthResponse} from "../providers/auth/auth";
import {AlertController} from "ionic-angular";
import {ErrorObservable} from "rxjs/observable/ErrorObservable";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  token;
  init = false;

  constructor(private authService: AuthProvider,
              private alertCtrl: AlertController) {

    this.getData();
  }

  getData() {
    return this.authService.getCrendentials.subscribe((res: AuthResponse) => {
      this.token = res.accessToken;
      this.init = true;
      return true;
    });
  }


  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    let addHeaders = () => {
      req = req.clone({
        setHeaders: {
          'Content-Type': 'application/json; charset=utf-8',
          'Accept': 'application/json',
          'Authorization': `Bearer ${this.token}`
        },
      });
      return next.handle(req);
    };

    return addHeaders()
      .catch((err) => this.handleErrors(err));

  }


  private handleErrors(err) {

    console.log("ERROR CAPTURADO EN INTERCEPTOR", err);

    // Status 403: Email is not yet verified

    if (err.status === 403) {
      this.alertCtrl.create({
        title: 'Error de confirmacion',
        message: `Para poder realizar compras y ver ordenes es necesario que confirmes tu correo electronico,
        puedes confirmarlo desde el apartado tu cuenta`,
        buttons: ['Entendido']
      }).present();

    }

    return new ErrorObservable(err);

  }

}



// WEBPACK FOOTER //
// ./src/utils/auth-interceptor.ts